import { createSchedule, updateSchedule } from "./ScheduleCURD";
import { v4 as uuidv4 } from 'uuid';
import { DialogUtility } from '@syncfusion/ej2-react-popups';
import { getCurrentDate, getCurrentDateByWeek, getCurrentView, validateTimesWithDetails } from "../../../util/CalendarUtil";
import { Timezone } from "@syncfusion/ej2-react-schedule";
import { debounce } from "lodash";
import { isClubOwner, isClubStaff, isCoach, isGuest, isUser } from '../../../util/UserRoles'
import { Privileges } from "../../../util/PrivilegeConstants";
import { rootAction } from "../../../redux/reducer/rootReducer";


//After editor's save button click 
const onSaveButtonClick = async (args, scheduleRef, userInfo, selectedClub, setIsRefresh, dispatch, calenderConfig) => {
    let formData = {};
    console.log("args on csa", args);
    const scheduleType = args.element.querySelector("#schedule_type").ej2_instances[0].value;
    const isRSVP = args.element.querySelector("#is_rsvp")?.ej2_instances[0]?.checked??false;
    const isAttachGuest = args.element.querySelector("#is_attach_guest")?.ej2_instances[0]?.checked??false;
    const isAttachAllMember = args.element.querySelector("#is_attach_all_member")?.ej2_instances[0]?.checked;
    const maxSlot = args.element.querySelector("#maxSlot")?.ej2_instances[0]?.value;
    const isEmailDispatch = args.element.querySelector("#isEmailDispatch") ? args.element.querySelector("#isEmailDispatch").ej2_instances[0].checked : false;
    const teams = args.element.querySelector('#PlayerAndTeam')?.ej2_instances[0]?.listData;
    const teamIds = args.element.querySelector('#PlayerAndTeam')?.ej2_instances[0]?.value;
    const subject = args.element.querySelector('#title').ej2_instances[0].value;
    const startTime = args.element.querySelector('#StartTime').ej2_instances[0].value;
    const endTime = args.element.querySelector('#EndTime').ej2_instances[0].value;
    const desc = args.element.querySelector('#Description').value;

    const isUpdateEntireSeries = !args.data?.hideRecurrenceEditor ?? false
    console.log("isUpdateEntireSeries <><>", isUpdateEntireSeries)

    
    const error = validateTimesWithDetails(startTime, endTime);
    

    if (error) {
        console.log(error);
        return;
    }
    if ((!teamIds || teamIds?.length === 0) && !isAttachAllMember) {
        return;
    }
    if (isRSVP && maxSlot < 1) {
        return;
    }
    if (desc?.length > 5000) {
        return;
    }
    if (subject?.length > 300) {
        return;
    }

    // Capture the recurrence rule securely by evaluating the DOM input element value first, 
    // and falling back to the parent series data if Syncfusion's editor UI hid or cleared the field.
    const resolvedRecurrenceRule = args.element.querySelector('#coach-recurrence-editor')?.ej2_instances?.[0]?.value || args?.data?.RecurrenceRule || args?.data?.recurrenceRule || null;

    const debouncedRefresh = debounce(() => {
        setIsRefresh(true);
        if (selectedClub.isPlanRequired) {
            dispatch(rootAction.setIsUpdateTotalSchedule(true));
        }
    }, 420);

    if (scheduleType === 'EVENT') {
        const IsAwayOrgRegistered = args.element.querySelector("#isAwayOrgRegisterd").ej2_instances[0].checked;
        let awayTeamId, awayOrg;
        const homeTeamId = args.element.querySelector("#home_team").ej2_instances[0].value;
        const CourtNumber = args.element.querySelector('#CourtNumber') ? args.element.querySelector('#CourtNumber')?.ej2_instances[0].value : null;
        if (IsAwayOrgRegistered) {
            awayTeamId = args.element.querySelector("#away_team").ej2_instances[0].value;
            awayOrg = args.element.querySelector("#AwayOrg").ej2_instances[0].value;
        }
        formData = {
            Id: args.target.classList.contains('e-appointment') ? args?.data?.Id : uuidv4(),
            Subject: subject,
            StartTime: startTime,
            EndTime: endTime,
            Description: desc,
            Venue: args.element.querySelector('#Vanue').value,
            EventId: args.element.querySelector('#Event').ej2_instances[0].value,
            HomeTeamId: homeTeamId,
            AwayTeamId: awayTeamId,
            ScheduleType: scheduleType,
            AwayOrgId: awayOrg,
            RecurrenceRule: resolvedRecurrenceRule,
            IsAllDay: false,
            IsAwayOrgRegistered: IsAwayOrgRegistered,
            AwayTeamName: IsAwayOrgRegistered ? null : args.element.querySelector("#AwayTeamNameText").ej2_instances[0].value,
            AwayOrganizationName: IsAwayOrgRegistered ? null : args.element.querySelector("#AwayOrganizationText").ej2_instances[0].value,
            CourtNumber: CourtNumber,
            IsRSVP: isRSVP,
            MaxSLot: maxSlot,
            IsEmailDispatch: isEmailDispatch,
            IsAttachAllMember: isAttachAllMember,
            IsAttachGuest:isAttachGuest,
            IsUpdateEntireSeries: isUpdateEntireSeries,
            IsPaid: (selectedClub?.isPlanRequired && calenderConfig?.scheduleCheckout && !isClubOwner(userInfo) && !isClubStaff(userInfo)) ? false : true
        };
    } else if (scheduleType === 'TEAM_PRACTICE' || scheduleType === 'MEET') {
        const CourtNumber = args.element.querySelector('#CourtNumber') ? args.element.querySelector('#CourtNumber')?.ej2_instances[0].value : null;
        const newTeams = teams?.filter((team) => teamIds.some(item => item === team.id));
        const venue = args.element.querySelector('#Venue').value;
        if (venue.length > 100) {
            return;
        }
        formData = {
            Id: args.target.classList.contains('e-appointment') ? args?.data?.Id : uuidv4(),
            Subject: subject,
            StartTime: startTime,
            EndTime: endTime,
            Description: desc,
            Venue: venue,
            EventId: args.element.querySelector('#Event').ej2_instances[0].value,
            ScheduleType: scheduleType,
            TeamIds: newTeams,
            RecurrenceRule: resolvedRecurrenceRule,
            IsAwayOrgRegistered: false,
            AwayTeamName: null,
            AwayOrganizationName: null,
            CourtNumber: CourtNumber,
            IsRSVP: isRSVP,
            MaxSlot: maxSlot,
            IsEmailDispatch: isEmailDispatch,
            IsAttachAllMember: isAttachAllMember,
            IsAttachGuest:isAttachGuest,
            IsUpdateEntireSeries: isUpdateEntireSeries,
            IsPaid: (selectedClub?.isPlanRequired && calenderConfig?.scheduleCheckout && !isClubOwner(userInfo) && !isClubStaff(userInfo)) ? false : true
        }
    } else {
        const CourtNumber = args.element.querySelector('#CourtNumber') ? args.element.querySelector('#CourtNumber')?.ej2_instances[0].value : null;
        const newTeams = teams?.filter((team) => teamIds.some(item => item === team.id));
        const venue = args.element?.querySelector('#Venue')?.value;
        if (venue && venue.length > 100) {
            return;
        }
        formData = {
            Id: args.target.classList.contains('e-appointment') ? args?.data?.Id : uuidv4(),
            Subject: subject,
            StartTime: startTime,
            EndTime: endTime,
            Description: desc,
            Venue: venue,
            ScheduleType: scheduleType,
            TeamIds: newTeams,
            RecurrenceRule: resolvedRecurrenceRule,
            IsAwayOrgRegistered: false,
            AwayTeamName: null,
            AwayOrganizationName: null,
            CourtNumber: CourtNumber,
            MeetingData: {
                mode: args.element?.querySelector('#MeetingMode')?.ej2_instances[0].value,
                platform: args.element?.querySelector('#Platform')?.ej2_instances[0].value,
            },
            IsRSVP: isRSVP,
            MaxSlot: maxSlot,
            IsEmailDispatch: isEmailDispatch,
            IsAttachGuest:isAttachGuest,
            IsAttachAllMember: isAttachAllMember,
            IsUpdateEntireSeries: isUpdateEntireSeries,
            IsPaid: (selectedClub?.isPlanRequired && calenderConfig?.scheduleCheckout && !isClubOwner(userInfo) && !isClubStaff(userInfo)) ? false : true
        }
    }

    if (args.target.classList.contains('e-appointment')) {
        // Build clear payload data mapping matching both case rules for safety
        formData = { 
            ...formData, 
            RecurrenceID: args.data.RecurrenceID ?? args.data.recurrenceId ?? null,
            recurrenceId: args.data.RecurrenceID ?? args.data.recurrenceId ?? null,
            recurrenceRule: formData.RecurrenceRule
        };

        //Update schedule in database
        updateSchedule(formData, userInfo.userId, selectedClub.clubId)
            .then((res) => {
                debouncedRefresh();
                scheduleRef.current.closeEditor();
            })
            .catch((error) => {
                console.log(error);

                let updateDialogObj = DialogUtility.alert({
                    title: 'Alert',
                    width: '250px',
                    position: { X: 'center', Y: 'center' },
                    animationSettings: { effect: 'Zoom' },
                    content: "something went wrong",
                    okButton: {
                        click: () => {
                            updateDialogObj.hide()
                        }
                    },
                });
                scheduleRef.current.closeEditor();
            })
    } else {
        // Create schedule in database
        createSchedule(formData, userInfo.userId, userInfo.userId, selectedClub.clubId)
            .then((res) => {
                debouncedRefresh();
                scheduleRef.current.closeEditor();
            })
            .catch((error) => {
                dispatch(rootAction.setIsUpdateTotalSchedule(true))
                let updateDialogObj = DialogUtility.alert({
                    title: 'Alert',
                    width: '250px',
                    position: { X: 'center', Y: 'center' },
                    animationSettings: { effect: 'Zoom' },
                    content: "something went wrong",
                    okButton: {
                        click: () => {
                            updateDialogObj.hide()
                        }
                    },
                });
                scheduleRef.current.closeEditor();
            })
    }
    scheduleRef.current.closeEditor();
}

export const onEventClick = (args, scheduleRef, userInfo, calenderConfig, privileges) => {
    if (calenderConfig.scheduleCheckout && args?.event?.IsPaid && !isClubOwner(userInfo)) {
        return;
    }
    if (!privileges?.RESERVATION?.includes(Privileges.MODIFY)) {
        return;
    }
    if (userInfo.userId !== args?.event?.ScheduleCreatedBy && !isClubOwner(userInfo)) {
        return;
    }

    let recurrenceDialog;
    let eventData = args.event;
    if (args.event.RecurrenceID || args.event.recurrenceId) {
        recurrenceDialog = DialogUtility.confirm({
            title: 'Edit Event',
            content: 'How would you like to change the appointment in the series?',
            width: '20vw',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            showCloseIcon: true,
            okButton: {
                text: 'EDIT EVENT',
                click: () => {
                    recurrenceDialog.hide();
                    eventData.hideRecurrenceEditor = true;
                    scheduleRef.current?.openEditor(eventData, 'Save');
                }
            },
            cancelButton: {
                text: 'ENTIRE SERIES',
                click: () => {
                    recurrenceDialog.hide();
                    eventData.hideRecurrenceEditor = false;
                    scheduleRef.current?.openEditor(eventData, 'Save');
                }
            }
        });
    } else {
        scheduleRef.current?.openEditor(eventData, 'Save');
    }
}

export const onSingleClick = (args, scheduleRef, privileges) => {
    if (args?.event?.target?.classList.contains("e-more-indicator")) {
        return;
    }

    if (!privileges?.RESERVATION?.includes(Privileges.CREATE)) {
        DialogUtility.confirm({
            title: 'Oops!!',
            content: 'You are not authorized to create event',
            width: '20vw',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            showCloseIcon: true,
        });
    } else {
        scheduleRef.current?.openEditor(args, 'Add');
    }
}

export const onPopupOpen = (args, scheduleRef, userInfo, selectedClub, setIsRefresh, dispatch, calenderConfig, privileges) => {
    if (args.type === "EventContainer" && args.name === 'popupOpen') {
        args.cancel = false;
        return;
    }

    // Disable Quick Info popup
    if ((args.type === "QuickInfo" || args.type === "ViewEventInfo") && !args.data.Id) {
        args.cancel = true;
    }
    if (!privileges?.RESERVATION?.includes(Privileges.MODIFY) && args.data.Id && !isClubOwner(userInfo)) {
        if (args.type === "QuickInfo" || args.type === "ViewEventInfo") {

        } else {
            args.cancel = true;
        }
    } else {
        if (args.type === "QuickInfo" || args.type === "ViewEventInfo") {
            args.cancel = true;
        }
    }

    if (args.type === 'Editor') {
        const saveButton = args.element.querySelector('#Save');
        const cancelButton = args.element.querySelector('#Cancel');

        let dialogObj;
        if (saveButton) {
            saveButton.onclick = () => {
                const isRSVP = args.element.querySelector("#is_rsvp")?.ej2_instances[0]?.checked;
                if (isRSVP && args?.Id) {
                    dialogObj = DialogUtility.confirm({
                        title: 'Warning',
                        content: 'If you update rsvp schedule then all rsvp requests are reset',
                        width: '300px',
                        position: { X: 'center', Y: 'center' },
                        animationSettings: { effect: 'Zoom' },
                        cssClass: 'fixthis',
                        okButton: { click: () =>{
                            onSaveButtonClick(args, scheduleRef, userInfo, selectedClub, setIsRefresh, dispatch, calenderConfig);
                            dialogObj.hide();
                        } },
                        cancelButton: {
                            click: () => {
                                dialogObj.hide();
                            }
                        }
                    });
                } else {
                    onSaveButtonClick(args, scheduleRef, userInfo, selectedClub, setIsRefresh, dispatch, calenderConfig);
                }
            }
        }
        cancelButton.onclick = () => {
            scheduleRef.current.closeEditor();
        };
    }
};

export const onActionComplete = (args, scheduleRef, dispatch) => {
    getCurrentView(scheduleRef, dispatch);
    if (args.requestType === "viewNavigate" || args.requestType === "dateNavigate") {
        if (scheduleRef.current?.viewIndex == 0) {
            getCurrentDate(scheduleRef, dispatch);
            scheduleRef.current.refreshTemplates();
        }
        if (scheduleRef.current?.viewIndex == 1 || scheduleRef.current?.viewIndex == 2 || scheduleRef.current?.viewIndex == 3) {
            getCurrentDateByWeek(scheduleRef, dispatch);
            scheduleRef.current.refreshTemplates();
        }
    }
}